import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=ba55708a"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports